import React from 'react';
import { useCurrency } from '../../context/CurrencyContext';

const CurrencySelector = () => {
    const { selectedCurrency, setSelectedCurrency } = useCurrency();



    const getDisplayText = (fullText) => {
        const match = fullText.match(/^[^)]+\)/);
        return match ? match[0] : fullText;
    };


    const currencyOptions = [
        {
            "value": "USD",
            "fullText": "USD ($) - US Dollar"
        },
        {
            "value": "AED",
            "fullText": "AED (د.إ) - UAE Dirham"
        },
        {
            "value": "AFN",
            "fullText": "AFN (؋) - Afghan Afghani"
        },
        {
            "value": "ALL",
            "fullText": "ALL (L) - Albanian Lek"
        },
        {
            "value": "AMD",
            "fullText": "AMD (֏) - Armenian Dram"
        },
        {
            "value": "ANG",
            "fullText": "ANG (ƒ) - Netherlands Antillean Guilder"
        },
        {
            "value": "AOA",
            "fullText": "AOA (Kz) - Angolan Kwanza"
        },
        {
            "value": "ARS",
            "fullText": "ARS ($) - Argentine Peso"
        },
        {
            "value": "AUD",
            "fullText": "AUD ($) - Australian Dollar"
        },
        {
            "value": "AWG",
            "fullText": "AWG (ƒ) - Aruban Florin"
        },
        {
            "value": "AZN",
            "fullText": "AZN (₼) - Azerbaijani Manat"
        },
        {
            "value": "BAM",
            "fullText": "BAM (КМ) - Bosnia and Herzegovina Convertible Mark"
        },
        {
            "value": "BBD",
            "fullText": "BBD ($) - Barbadian Dollar"
        },
        {
            "value": "BDT",
            "fullText": "BDT (৳) - Bangladeshi Taka"
        },
        {
            "value": "BGN",
            "fullText": "BGN (лв) - Bulgarian Lev"
        },
        {
            "value": "BHD",
            "fullText": "BHD (د.ب) - Bahraini Dinar"
        },
        {
            "value": "BIF",
            "fullText": "BIF (Fr) - Burundian Franc"
        },
        {
            "value": "BMD",
            "fullText": "BMD ($) - Bermudian Dollar"
        },
        {
            "value": "BND",
            "fullText": "BND ($) - Brunei Dollar"
        },
        {
            "value": "BOB",
            "fullText": "BOB (Bs.) - Bolivian Boliviano"
        },
        {
            "value": "BRL",
            "fullText": "BRL (R$) - Brazilian Real"
        },
        {
            "value": "BSD",
            "fullText": "BSD ($) - Bahamian Dollar"
        },
        {
            "value": "BTN",
            "fullText": "BTN (Nu.) - Bhutanese Ngultrum"
        },
        {
            "value": "BWP",
            "fullText": "BWP (P) - Botswanan Pula"
        },
        {
            "value": "BYN",
            "fullText": "BYN (Br) - Belarusian Ruble"
        },
        {
            "value": "BZD",
            "fullText": "BZD ($) - Belize Dollar"
        },
        {
            "value": "CAD",
            "fullText": "CAD ($) - Canadian Dollar"
        },
        {
            "value": "CDF",
            "fullText": "CDF (Fr) - Congolese Franc"
        },
        {
            "value": "CHF",
            "fullText": "CHF (Fr) - Swiss Franc"
        },
        {
            "value": "CLP",
            "fullText": "CLP ($) - Chilean Peso"
        },
        {
            "value": "CNY",
            "fullText": "CNY (¥) - Chinese Yuan"
        },
        {
            "value": "COP",
            "fullText": "COP ($) - Colombian Peso"
        },
        {
            "value": "CRC",
            "fullText": "CRC (₡) - Costa Rican Colón"
        },
        {
            "value": "CUP",
            "fullText": "CUP ($) - Cuban Peso"
        },
        {
            "value": "CVE",
            "fullText": "CVE ($) - Cape Verdean Escudo"
        },
        {
            "value": "CZK",
            "fullText": "CZK (Kč) - Czech Koruna"
        },
        {
            "value": "DJF",
            "fullText": "DJF (Fr) - Djiboutian Franc"
        },
        {
            "value": "DKK",
            "fullText": "DKK (kr) - Danish Krone"
        },
        {
            "value": "DOP",
            "fullText": "DOP ($) - Dominican Peso"
        },
        {
            "value": "DZD",
            "fullText": "DZD (د.ج) - Algerian Dinar"
        },
        {
            "value": "EGP",
            "fullText": "EGP (£) - Egyptian Pound"
        },
        {
            "value": "ERN",
            "fullText": "ERN (Nfk) - Eritrean Nakfa"
        },
        {
            "value": "ETB",
            "fullText": "ETB (Br) - Ethiopian Birr"
        },
        {
            "value": "EUR",
            "fullText": "EUR (€) - Euro"
        },
        {
            "value": "FJD",
            "fullText": "FJD ($) - Fijian Dollar"
        },
        {
            "value": "FKP",
            "fullText": "FKP (£) - Falkland Islands Pound"
        },
        {
            "value": "GBP",
            "fullText": "GBP (£) - Pound Sterling"
        },
        {
            "value": "GEL",
            "fullText": "GEL (₾) - Georgian Lari"
        },
        {
            "value": "GHS",
            "fullText": "GHS (₵) - Ghanaian Cedi"
        },
        {
            "value": "GIP",
            "fullText": "GIP (£) - Gibraltar Pound"
        },
        {
            "value": "GMD",
            "fullText": "GMD (D) - Gambian Dalasi"
        },
        {
            "value": "GNF",
            "fullText": "GNF (Fr) - Guinean Franc"
        },
        {
            "value": "GTQ",
            "fullText": "GTQ (Q) - Guatemalan Quetzal"
        },
        {
            "value": "GYD",
            "fullText": "GYD ($) - Guyanese Dollar"
        },
        {
            "value": "HKD",
            "fullText": "HKD ($) - Hong Kong Dollar"
        },
        {
            "value": "HNL",
            "fullText": "HNL (L) - Honduran Lempira"
        },
        {
            "value": "HTG",
            "fullText": "HTG (G) - Haitian Gourde"
        },
        {
            "value": "HUF",
            "fullText": "HUF (Ft) - Hungarian Forint"
        },
        {
            "value": "IDR",
            "fullText": "IDR (Rp) - Indonesian Rupiah"
        },
        {
            "value": "ILS",
            "fullText": "ILS (₪) - Israeli New Shekel"
        },
        {
            "value": "INR",
            "fullText": "INR (₹) - Indian Rupee"
        },
        {
            "value": "IQD",
            "fullText": "IQD (ع.د) - Iraqi Dinar"
        },
        {
            "value": "IRR",
            "fullText": "IRR (﷼) - Iranian Rial"
        },
        {
            "value": "ISK",
            "fullText": "ISK (kr) - Icelandic Króna"
        },
        {
            "value": "JMD",
            "fullText": "JMD ($) - Jamaican Dollar"
        },
        {
            "value": "JOD",
            "fullText": "JOD (د.ا) - Jordanian Dinar"
        },
        {
            "value": "JPY",
            "fullText": "JPY (¥) - Japanese Yen"
        },
        {
            "value": "KES",
            "fullText": "KES (Sh) - Kenyan Shilling"
        },
        {
            "value": "KGS",
            "fullText": "KGS (с) - Kyrgyzstani Som"
        },
        {
            "value": "KHR",
            "fullText": "KHR (៛) - Cambodian Riel"
        },
        {
            "value": "KMF",
            "fullText": "KMF (Fr) - Comorian Franc"
        },
        {
            "value": "KPW",
            "fullText": "KPW (₩) - North Korean Won"
        },
        {
            "value": "KRW",
            "fullText": "KRW (₩) - South Korean Won"
        },
        {
            "value": "KWD",
            "fullText": "KWD (د.ك) - Kuwaiti Dinar"
        },
        {
            "value": "KYD",
            "fullText": "KYD ($) - Cayman Islands Dollar"
        },
        {
            "value": "KZT",
            "fullText": "KZT (₸) - Kazakhstani Tenge"
        },
        {
            "value": "LAK",
            "fullText": "LAK (₭) - Lao Kip"
        },
        {
            "value": "LBP",
            "fullText": "LBP (ل.ل) - Lebanese Pound"
        },
        {
            "value": "LKR",
            "fullText": "LKR (Rs) - Sri Lankan Rupee"
        },
        {
            "value": "LRD",
            "fullText": "LRD ($) - Liberian Dollar"
        },
        {
            "value": "LSL",
            "fullText": "LSL (L) - Lesotho Loti"
        },
        {
            "value": "LYD",
            "fullText": "LYD (ل.د) - Libyan Dinar"
        },
        {
            "value": "MAD",
            "fullText": "MAD (د.م.) - Moroccan Dirham"
        },
        {
            "value": "MDL",
            "fullText": "MDL (L) - Moldovan Leu"
        },
        {
            "value": "MGA",
            "fullText": "MGA (Ar) - Malagasy Ariary"
        },
        {
            "value": "MKD",
            "fullText": "MKD (ден) - Macedonian Denar"
        },
        {
            "value": "MMK",
            "fullText": "MMK (Ks) - Myanmar Kyat"
        },
        {
            "value": "MNT",
            "fullText": "MNT (₮) - Mongolian Tögrög"
        },
        {
            "value": "MOP",
            "fullText": "MOP (P) - Macanese Pataca"
        },
        {
            "value": "MRU",
            "fullText": "MRU (UM) - Mauritanian Ouguiya"
        },
        {
            "value": "MUR",
            "fullText": "MUR (₨) - Mauritian Rupee"
        },
        {
            "value": "MVR",
            "fullText": "MVR (ރ.) - Maldivian Rufiyaa"
        },
        {
            "value": "MWK",
            "fullText": "MWK (MK) - Malawian Kwacha"
        },
        {
            "value": "MXN",
            "fullText": "MXN ($) - Mexican Peso"
        },
        {
            "value": "MYR",
            "fullText": "MYR (RM) - Malaysian Ringgit"
        },
        {
            "value": "MZN",
            "fullText": "MZN (MT) - Mozambican Metical"
        },
        {
            "value": "N/A",
            "fullText": "N/A (N/A) - No official currency"
        },
        {
            "value": "NAD",
            "fullText": "NAD ($) - Namibian Dollar"
        },
        {
            "value": "NGN",
            "fullText": "NGN (₦) - Nigerian Naira"
        },
        {
            "value": "NIO",
            "fullText": "NIO (C$) - Nicaraguan Córdoba"
        },
        {
            "value": "NOK",
            "fullText": "NOK (kr) - Norwegian Krone"
        },
        {
            "value": "NPR",
            "fullText": "NPR (₨) - Nepalese Rupee"
        },
        {
            "value": "NZD",
            "fullText": "NZD ($) - New Zealand Dollar"
        },
        {
            "value": "OMR",
            "fullText": "OMR (ر.ع.) - Omani Rial"
        },
        {
            "value": "PAB",
            "fullText": "PAB (B/.) - Panamanian Balboa"
        },
        {
            "value": "PEN",
            "fullText": "PEN (S/) - Peruvian Sol"
        },
        {
            "value": "PGK",
            "fullText": "PGK (K) - Papua New Guinean Kina"
        },
        {
            "value": "PHP",
            "fullText": "PHP (₱) - Philippine Peso"
        },
        {
            "value": "PKR",
            "fullText": "PKR (₨) - Pakistani Rupee"
        },
        {
            "value": "PLN",
            "fullText": "PLN (zł) - Polish Złoty"
        },
        {
            "value": "PYG",
            "fullText": "PYG (₲) - Paraguayan Guaraní"
        },
        {
            "value": "QAR",
            "fullText": "QAR (ر.ق) - Qatari Riyal"
        },
        {
            "value": "RON",
            "fullText": "RON (lei) - Romanian Leu"
        },
        {
            "value": "RSD",
            "fullText": "RSD (дин) - Serbian Dinar"
        },
        {
            "value": "RUB",
            "fullText": "RUB (₽) - Russian Ruble"
        },
        {
            "value": "RWF",
            "fullText": "RWF (Fr) - Rwandan Franc"
        },
        {
            "value": "SAR",
            "fullText": "SAR (ر.س) - Saudi Riyal"
        },
        {
            "value": "SBD",
            "fullText": "SBD ($) - Solomon Islands Dollar"
        },
        {
            "value": "SCR",
            "fullText": "SCR (₨) - Seychellois Rupee"
        },
        {
            "value": "SDG",
            "fullText": "SDG (ج.س.) - Sudanese Pound"
        },
        {
            "value": "SEK",
            "fullText": "SEK (kr) - Swedish Krona"
        },
        {
            "value": "SGD",
            "fullText": "SGD ($) - Singapore Dollar"
        },
        {
            "value": "SHP",
            "fullText": "SHP (£) - Saint Helena Pound"
        },
        {
            "value": "SLL",
            "fullText": "SLL (Le) - Sierra Leonean Leone"
        },
        {
            "value": "SOS",
            "fullText": "SOS (Sh) - Somali Shilling"
        },
        {
            "value": "SRD",
            "fullText": "SRD ($) - Surinamese Dollar"
        },
        {
            "value": "SSP",
            "fullText": "SSP (£) - South Sudanese Pound"
        },
        {
            "value": "STN",
            "fullText": "STN (Db) - São Tomé and Príncipe Dobra"
        },
        {
            "value": "SYP",
            "fullText": "SYP (ل.س) - Syrian Pound"
        },
        {
            "value": "SZL",
            "fullText": "SZL (L) - Swazi Lilangeni"
        },
        {
            "value": "THB",
            "fullText": "THB (฿) - Thai Baht"
        },
        {
            "value": "TJS",
            "fullText": "TJS (ЅМ) - Tajikistani Somoni"
        },
        {
            "value": "TMT",
            "fullText": "TMT (m) - Turkmenistani Manat"
        },
        {
            "value": "TND",
            "fullText": "TND (د.ت) - Tunisian Dinar"
        },
        {
            "value": "TOP",
            "fullText": "TOP (T$) - Tongan Paʻanga"
        },
        {
            "value": "TRY",
            "fullText": "TRY (₺) - Turkish Lira"
        },
        {
            "value": "TTD",
            "fullText": "TTD ($) - Trinidad and Tobago Dollar"
        },
        {
            "value": "TWD",
            "fullText": "TWD ($) - New Taiwan Dollar"
        },
        {
            "value": "TZS",
            "fullText": "TZS (Sh) - Tanzanian Shilling"
        },
        {
            "value": "UAH",
            "fullText": "UAH (₴) - Ukrainian Hryvnia"
        },
        {
            "value": "UGX",
            "fullText": "UGX (Sh) - Ugandan Shilling"
        },
        {
            "value": "UYU",
            "fullText": "UYU ($) - Uruguayan Peso"
        },
        {
            "value": "UZS",
            "fullText": "UZS (so'm) - Uzbekistani Som"
        },
        {
            "value": "VES",
            "fullText": "VES (Bs.) - Venezuelan Bolívar"
        },
        {
            "value": "VND",
            "fullText": "VND (₫) - Vietnamese Dong"
        },
        {
            "value": "VUV",
            "fullText": "VUV (Vt) - Vanuatu Vatu"
        },
        {
            "value": "WST",
            "fullText": "WST (T) - Samoan Tala"
        },
        {
            "value": "XAF",
            "fullText": "XAF (Fr) - CFA Franc BEAC"
        },
        {
            "value": "XCD",
            "fullText": "XCD ($) - East Caribbean Dollar"
        },
        {
            "value": "XOF",
            "fullText": "XOF (Fr) - CFA Franc BCEAO"
        },
        {
            "value": "XPF",
            "fullText": "XPF (Fr) - CFP Franc"
        },
        {
            "value": "YER",
            "fullText": "YER (﷼) - Yemeni Rial"
        },
        {
            "value": "ZAR",
            "fullText": "ZAR (R) - South African Rand"
        },
        {
            "value": "ZMW",
            "fullText": "ZMW (ZK) - Zambian Kwacha"
        },
        {
            "value": "ZWL",
            "fullText": "ZWL ($) - Zimbabwe Dollar"
        }
    ];

    const handleCurrencyChange = (e) => {
        setSelectedCurrency(e.target.value);
    };


    const selectedOption = currencyOptions.find(option => option.value === selectedCurrency);
    const displayText = selectedOption ? getDisplayText(selectedOption.fullText) : '';

    return (
        <div className="p-6">
            <div className="relative mb-4">
                <select
                    id="currency-select"
                    value={selectedCurrency}
                    onChange={handleCurrencyChange}
                    className="border border-gray-300 rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none bg-white"
                    style={{
                        color: 'transparent',
                        width: '100%',
                        maxWidth: '100px'
                    }}
                >
                    {currencyOptions.map(option => (
                        <option key={option.value} value={option.value} style={{ color: 'black' }}>
                            {option.fullText}
                        </option>
                    ))}
                </select>

                {/* Overlay to show custom display text */}
                <div className="absolute inset-0 px-2 py-1 text-sm pointer-events-none flex items-center" style={{ maxWidth: '200px' }}>
                    {displayText}
                </div>
            </div>
        </div>
    );
};


export default CurrencySelector;


// List of all the currency:

// 'USD', 'EUR', 'JPY', 'GBP', 'CHF', 'CAD', 'AUD', 'NZD', 'CNY', 'HKD', 'SGD', 'KRW', 'SEK', 'NOK', 'DKK', 'INR', 'RUB', 'BRL', 'ZAR', 'MXN', 'TRY', 'THB', 'IDR', 'MYR', 'PHP', 'PLN', 'CZK', 'HUF', 'ILS', 'SAR', AED, AFN, ALL, AMD, ANG, AOA, ARS, AUD, AWG, AZN, BAM, BBD, BDT, BGN, BHD, BIF, BMD, BND, BOB, BRL, BSD, BTN, BWP, BYN, BZD, CAD, CDF, CHF, CLP, CNY, COP, CRC, CUP, CVE, CZK, DJF, DKK, DOP, DZD, EGP, ERN, ETB, EUR, FJD, FKP, GBP, GEL, GHS, GIP, GMD, GNF, GTQ, GYD, HKD, HNL, HTG, HUF, IDR, ILS, INR, IQD, IRR, ISK, JMD, JOD, JPY, KES, KGS, KHR, KMF, KPW, KRW, KWD, KYD, KZT, LAK, LBP, LKR, LRD, LSL, LYD, MAD, MDL, MGA, MKD, MMK, MNT, MOP, MRU, MUR, MVR, MWK, MXN, MYR, MZN, NAD, NGN, NIO, NOK, NPR, NZD, OMR, PAB, PEN, PGK, PHP, PKR, PLN, PYG, QAR, RON, RSD, RUB, RWF, SAR, SBD, SCR, SDG, SEK, SGD, SHP, SLL, SOS, SRD, SSP, STN, SYP, SZL, THB, TJS, TMT, TND, TOP, TRY, TTD, TWD, TZS, UAH, UGX, USD, UYU, UZS, VES, VND, VUV, WST, XAF, XCD, XOF, XPF, YER, ZAR, ZMW, ZWL

// AED
// AFN
// ALL
// AMD
// ANG
// AOA
// ARS
// AUD
// AWG
// AZN
// BAM
// BBD
// BDT
// BGN
// BHD
// BIF
// BMD
// BND
// BOB
// BRL
// BSD
// BTN
// BWP
// BYN
// BZD
// CAD
// CDF
// CHF
// CLP
// CNY
// COP
// CRC
// CUP
// CVE
// CZK
// DJF
// DKK
// DOP
// DZD
// EGP
// ERN
// ETB
// EUR
// FJD
// FKP
// GBP
// GEL
// GHS
// GIP
// GMD
// GNF
// GTQ
// GYD
// HKD
// HNL
// HTG
// HUF
// IDR
// ILS
// INR
// IQD
// IRR
// ISK
// JMD
// JOD
// JPY
// KES
// KGS
// KHR
// KMF
// KPW
// KRW
// KWD
// KYD
// KZT
// LAK
// LBP
// LKR
// LRD
// LSL
// LYD
// MAD
// MDL
// MGA
// MKD
// MMK
// MNT
// MOP
// MRU
// MUR
// MVR
// MWK
// MXN
// MYR
// MZN
// NAD
// NGN
// NIO
// NOK
// NPR
// NZD
// OMR
// PAB
// PEN
// PGK
// PHP
// PKR
// PLN
// PYG
// QAR
// RON
// RSD
// RUB
// RWF
// SAR
// SBD
// SCR
// SDG
// SEK
// SGD
// SHP
// SLL
// SOS
// SRD
// SSP
// STN
// SYP
// SZL
// THB
// TJS
// TMT
// TND
// TOP
// TRY
// TTD
// TWD
// TZS
// UAH
// UGX
// USD
// UYU
// UZS
// VES
// VND
// VUV
// WST
// XAF
// XCD
// XOF
// XPF
// YER
// ZAR
// ZMW
// ZWL

